function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Mark } from 'prosemirror-model';
import { hasNativeEmojiSupport, substituteColonifiedForUnicode } from '@intercom/embercom-prosemirror-composer/lib/helpers/emoji';

// The interface to TextNodes is a little different but there is no explicit typing,
// see https://github.com/ProseMirror/prosemirror-model/blob/master/src/node.js#L371

export class DocumentBuilder {
  constructor(schema) {
    _defineProperty(this, "schema", void 0);
    _defineProperty(this, "stack", void 0);
    _defineProperty(this, "marks", void 0);
    _defineProperty(this, "docNode", void 0);
    this.schema = schema;
    this.stack = [{
      type: schema.topNodeType,
      infoContent: [],
      content: []
    }];
    this.marks = Mark.none;
  }
  get doc() {
    if (!this.docNode) {
      if (this.stack.length !== 1) {
        throw new Error('Document has unclosed nodes');
      }
      this.docNode = this.closeNode();
    }
    return this.docNode;
  }
  top() {
    return this.stack[this.stack.length - 1];
  }
  push(node) {
    if (this.stack.length) {
      this.top().content.push(node);
    }
  }
  openNode(type, attrs) {
    this.stack.push({
      type,
      attrs,
      infoContent: [],
      content: []
    });
  }
  closeNode() {
    let info = this.stack.pop();
    if (!info) {
      throw new Error('Tried to close a non existent node');
    }
    let node = info.type.createAndFill(info.attrs, info.content, this.marks);
    if (!node) {
      throw new Error('Undefined node type');
    }
    this.push(node);
    return node;
  }
  addText(text) {
    if (!text) {
      return;
    }
    if (!hasNativeEmojiSupport()) {
      text = substituteColonifiedForUnicode(text);
    }
    let nodes = this.top().content;
    let last = nodes[nodes.length - 1];
    let node = this.schema.text(text, this.marks);
    let merged = last && this.maybeMerge(last, node);
    if (merged) {
      nodes[nodes.length - 1] = merged;
    } else {
      nodes.push(node);
    }
  }
  openMark(mark) {
    this.marks = mark.addToSet(this.marks);
  }
  closeMark(mark) {
    this.marks = mark.removeFromSet(this.marks);
  }
  maybeMerge(a, b) {
    if (a.isText && b.isText && Mark.sameSet(a.marks, b.marks)) {
      return a.withText(a.text + b.text);
    }
    return undefined;
  }
}